module.exports = __webpack_public_path__ + "static/media/company--bg2.87afbb50.jpg";